export default __webpack_public_path__ + "static/bretagne_self-modern_text_web-ffbd94da4826e95feff94b4b979cc041.woff";